var React = require('react');

function Enlarge (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m39.59 8.47a1 1 0 0 0 -1 1 1 1 0 0 0 1 1h12.64l-41.88 41.69v-12.65a1 1 0 0 0 -2 0l-.01 16.07h16.07a1 1 0 0 0 1-1 1 1 0 0 0 -1-1h-12.64l41.88-41.74v12.65a1 1 0 0 0 2 0v-16.08z"}));
}

Enlarge.defaultProps = {"id":"Layer_1","height":"512","viewBox":"0 0 64 64","width":"512","data-name":"Layer 1"};

module.exports = Enlarge;

Enlarge.default = Enlarge;
